import { SimpleSelect, Spinner } from "@instructure/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const PresentationModeSelector = ({ contextId, currentMode, onModeChange }) => {
  const { t } = useTranslation();
  const [isPersisting, setIsPersisting] = useState(false);

  async function handleChange(_e, { value }) {
    setIsPersisting(true);
    try {
      await onModeChange(value);
    } finally {
      setIsPersisting(false);
    }
  }

  return (
    <SimpleSelect
      renderLabel={t("results.displayFormat")}
      value={currentMode}
      onChange={handleChange}
      interaction={isPersisting ? "disabled" : "enabled"}
      renderAfterInput={
        isPersisting ? (
          <Spinner size="x-small" renderTitle={t("global.pleaseWait")} />
        ) : null
      }
    >
      <SimpleSelect.Option
        id={`presentation-mode-bar-chart-${contextId}`}
        value="bar_chart"
      >
        {t("results.barChart")}
      </SimpleSelect.Option>
      <SimpleSelect.Option
        id={`presentation-mode-table-${contextId}`}
        value="table"
      >
        {t("courseReview.table")}
      </SimpleSelect.Option>
    </SimpleSelect>
  );
};

export default PresentationModeSelector;
